<template>UAEPass logout......</template>
<script setup>
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const authStore = useAuthStore()
authStore.UAEPassLogout()
router.push('/')
</script>
